import React from "react";
import { useTranslation } from "react-i18next";
import { Stack, TextField, MenuItem } from "@mui/material";
import { GENDER_KEYS } from "../../constants/funnel";
import { SectionProps } from "./profileShared";

/** Naam, bio en geslacht — hoe de provider zich voorstelt aan cliënten. */
export default function BasicsSection({ profile, onChange }: SectionProps) {
  const { t } = useTranslation();
  return (
    <Stack spacing={2.5}>
      <TextField label={t("dashboard.displayName")} required value={profile.displayName} onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange({ ...profile, displayName: e.target.value })} fullWidth />
      <TextField label={t("dashboard.bio")} value={profile.bio} onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange({ ...profile, bio: e.target.value })} multiline minRows={5} fullWidth />
      <TextField select label={t("dashboard.gender")} value={profile.gender} onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange({ ...profile, gender: e.target.value })} sx={{ maxWidth: 220 }}>
        {GENDER_KEYS.map((k) => <MenuItem key={k || "none"} value={k}>{k ? t(`genderPref.${k}`) : t("dashboard.genderNone")}</MenuItem>)}
      </TextField>
    </Stack>
  );
}
